import { Grid } from '@mui/material';
import { FC, useState, useCallback } from 'react';
import StudentFeesGrid from './studentFeesGrid.view';
import { TStudentFeeSummaryMap } from './studentFees.interfaces';
import EditStudentFeeModal from './EditStudentFeeModal';
import { useStudentFiltersState } from '../../contexts/studentFilters.context';
import { useStudentsState } from '../../contexts/students.context';
import { PermissionGate } from '../../../../../components/rbac/PermissionGate';
import { RbacDeniedRedirect } from '../../../../../components/rbac/RbacDeniedRedirect';

const StudentFeesView: FC = () => {
  const [isEditFeeModalOpen, setIsEditFeeModalOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState<string | null>(null);
  const filters = useStudentFiltersState();
  const { isLoading } = useStudentsState();

  const onRowClickHandler = useCallback((data: TStudentFeeSummaryMap) => {
    setIsEditFeeModalOpen(true);
    setSelectedStudent(data.id);
  }, []);

  return (
    <PermissionGate
      module="students"
      submodule="fees"
      permission="read"
      fallback={<RbacDeniedRedirect />}
    >
      <Grid
        container
        spacing={{ xs: 1, sm: 2 }}
        sx={{
          height: '100%',
          p: { xs: 1, sm: 2 },
        }}
        data-testid="student-fees-view-container"
      >
        <StudentFeesGrid
          onRowClick={onRowClickHandler}
          key={`${filters.grade}-${filters.section}`}
          isLoading={isLoading}
        />
        <EditStudentFeeModal
          isOpen={isEditFeeModalOpen}
          onClose={() => setIsEditFeeModalOpen(false)}
          selectedStudent={selectedStudent}
        />
      </Grid>
    </PermissionGate>
  );
};

export default StudentFeesView;
